import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePickerModel } from 'src/app/components/date-picker-dialog/date-picker.model';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { PriceyardService } from 'src/app/modules/priceyard/services/priceyard.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-dashboard-priceyard-panel',
  templateUrl: './dashboard-priceyard-panel.component.html',
  styleUrls: ['./dashboard-priceyard-panel.component.scss']
})
export class DashboardPriceyardPanelComponent implements OnInit, OnDestroy {
  @Input() sku;
  @Input() id;
  buyBoxWinningData: any;
  buyBoxWinningChartColors: any[] = ['#3B6EFF']
  buyBoxWinninglabels: any[];
  salesData: any;
  salesChartColors: any[] = ['#FFA600']
  saleslabels: any[];
  competitionData: any;
  competitionChartColors: any[] = ['#31D093']
  competitionlabels: any[];
  repriceActivityData: any;
  repriceActivityChartColors: any[] = ['#3B6EFF']
  repriceActivitylabels: any[];
  loading: boolean;
  private destroy$ = new Subject<void>();
  currentDateFilter: DatePickerModel;
  summary: any;
  buyBoxWinningLoading: boolean;
  salesDataLoading: boolean;
  competitionDataLoading: boolean;
  repriceActivityLoading: boolean;
  isSidePanel: boolean;
  spin;
  dialogRef;
  constructor(private dashboardService: DashboardService,
   private snackBar: MatSnackBar,
   private priceyardService: PriceyardService) {
    this.dashboardService.selectedDate$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res) { 
        this.spin = res?.spinner;
        this.dialogRef = res?.dialogRef; 
        if(res.isWinningBuyBox){
          this.getWinninyBuyBox(res);
        } else if(res.isRepriceActivity){
          this.getRepriceActtivity(res);
        } else if(res.isCompetition){
          this.getCompetition(res);
        } else if(res.isSales){
          this.getSales(res);
        }   
      }
    })
    this.isSidePanel = localStorage.getItem("toolPanel") === "true";
   }

  ngOnInit(): void {
    const today = new Date();
    this.currentDateFilter={
      to: today,
      from:new Date(today.getTime() - this.getDaysAgo(30)),
      label:'Last 30 Days'
    }
    let payload: any ={
      endDate: new Date(),
      startDate:  new Date(new Date().getTime() - this.getDaysAgo(30))
    }
    this.getWinninyBuyBox(payload,true);
    this.getSales(payload,true);
    this.getCompetition(payload,true);
    this.getRepriceActtivity(payload,true);
    this.getSummary(payload);
  }

  getWinninyBuyBox(res,isRefresh = false){
    let payload: any ={
      endDate: res ?  new Date(res.endDate) : new Date(),
      startDate:  res ?  new Date(res.startDate) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.sku?.accountSkuId
    }
    if(isRefresh) this.buyBoxWinningLoading = true;
    this.priceyardService.BlackBoxWinningPricingListSummary(payload).subscribe((res:any)=>{
      this.buyBoxWinninglabels = res.map((res) => res.label)
      this.buyBoxWinningData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.buyBoxWinningLoading = false;
      this.spin = false;
      this.dialogRef?.close();
     },(error)=>{
      this.spin = false;
      this.dialogRef?.close();
      this.buyBoxWinningLoading = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getSales(res,isRefresh = false){
    let payload: any ={
      endDate: res ?  new Date(res.endDate) : new Date(),
      startDate:  res ?  new Date(res.startDate) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.sku?.accountSkuId
    }
    if(isRefresh) this.salesDataLoading = true;
    this.priceyardService.SalesPricingListSummary(payload).subscribe((res:any)=>{
      this.salesDataLoading = false;
      this.spin = false;
      this.dialogRef?.close();
      this.saleslabels = res.map((res) => res.label)
      this.salesData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
     },(error)=>{
      this.salesDataLoading = false;
      this.spin = false;
      this.dialogRef?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getCompetition(res,isRefresh = false){
    let payload: any ={
      endDate: res ?  new Date(res.endDate) : new Date(),
      startDate:  res ?  new Date(res.startDate) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.sku?.accountSkuId
    }
    if(isRefresh) this.competitionDataLoading = true;
    this.priceyardService.CompetitionPricingListSummary(payload).subscribe((res:any)=>{
      this.spin = false;
      this.dialogRef?.close();
      this.competitionlabels = res.map((res) => res.label)
      this.competitionData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.competitionDataLoading = false;
     },(error)=>{     
      this.competitionDataLoading = false;
      this.spin = false;
      this.dialogRef?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getRepriceActtivity(res,isRefresh = false){
    let payload: any ={
      endDate: res ?  new Date(res.endDate) : new Date(),
      startDate:  res ?  new Date(res.startDate) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.sku?.accountSkuId
    }
    if(isRefresh) this.repriceActivityLoading = true;
    this.priceyardService.RepriceActivityPricingListSummary(payload).subscribe((res:any)=>{
      this.repriceActivitylabels = res.map((res) => res.label)
      this.repriceActivityData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.spin = false;
      this.dialogRef?.close();
      this.repriceActivityLoading = false;
     },(error)=>{
      this.spin = false;
      this.dialogRef?.close();
      this.repriceActivityLoading = false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getSummary(res){
    let payload: any ={
      endDate: new Date(),
      startDate:  new Date(new Date().getTime() - this.getDaysAgo(7)),
      accountSkuId: this.sku?.accountSkuId
    }
    this.priceyardService.GetSummaryByAccountSkuId(payload).subscribe((res:any)=>{
      this.summary =  res;
     },(error)=>{
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }
}